/* eslint-disable no-shadow */
/* eslint-disable import/no-named-as-default */
import React, { Component, createRef, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { loadMorePosts } from "../../actions/activityFeedActions";
import ErrorBoundary from "../shared/error/ErrorBoundary";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import ActivityFeedPost from "./ActivityFeedPost";
import MiniSpinner from "../shared/loaders/MiniSpinner";
import {
  Wrapper,
  Header,
  Title,
  BetaBadge,
  CloseButton,
  FeedWrapper,
  Loaded,
  Error,
  NoPosts,
} from "./styles/activity-feed-styles";

export class Mobile extends Component {
  constructor(props) {
    super(props);
    this.wrapper = createRef();
  }

  handleCloseButton = () => {
    const wrapper = this.wrapper.current;
    wrapper.classList.remove("active");
  };

  render() {
    const {
      posts,
      errors,
      loadMorePosts,
      loading,
      page,
      hasMore,
      isPortalUser,
    } = this.props;

    return (
      <Wrapper id="activity-feed" ref={this.wrapper}>
        <ErrorBoundary>
          {loading ? (
            <WidgetLoading />
          ) : (
            <Fragment>
              <Header>
                <Title>
                  {isPortalUser && "marketplace "} activity feed
                  <BetaBadge>new!</BetaBadge>
                </Title>
                <CloseButton onClick={() => this.handleCloseButton()}>
                  <FontAwesomeIcon icon={faTimes} />
                </CloseButton>
              </Header>
              <FeedWrapper ref={this.feedWrapper} id="feed-wrapper">
                {errors && <Error>Error occurred</Error>}
                {posts.length < 1 && <NoPosts />}
                <InfiniteScroll
                  dataLength={posts.length}
                  next={() => loadMorePosts(page)}
                  hasMore={hasMore}
                  scrollableTarget="feed-wrapper"
                  loader={
                    <MiniSpinner
                      size={20}
                      absolute
                      top={12}
                      right={20}
                      mobileTop={11}
                      mobileRight={50}
                    />
                  }
                  endMessage={
                    <Loaded>
                      <span role="img" aria-label="confetti emoji">
                        🎉
                      </span>{" "}
                      Yay! You have seen it all.
                    </Loaded>
                  }
                >
                  {posts.map((post) => (
                    <ActivityFeedPost key={post.id} post={post} />
                  ))}
                </InfiniteScroll>
              </FeedWrapper>
            </Fragment>
          )}
        </ErrorBoundary>
      </Wrapper>
    );
  }
}

Mobile.propTypes = {
  loadMorePosts: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  hasMore: PropTypes.bool.isRequired,
  page: PropTypes.number,
  posts: PropTypes.arrayOf(PropTypes.shape({})),
  errors: PropTypes.shape({}),
  isPortalUser: PropTypes.bool.isRequired,
};

Mobile.defaultProps = {
  posts: PropTypes.isNull,
  errors: PropTypes.isNull,
  page: PropTypes.number.isNull,
};

const mapStateToProps = (state) => ({
  loading: state.activityFeed.loading,
  posts: state.activityFeed.posts,
  page: state.activityFeed.page,
  hasMore: state.activityFeed.hasMore,
  isPortalUser: state.activityFeed.isPortalUser,
});

export default connect(mapStateToProps, { loadMorePosts })(Mobile);
